import { notification } from 'antd';
import { v4 as uuid } from 'uuid';
const createNotification = (type, message, description, onClick, key) => {
    notification[type]({
        message,
        description,
        onClick,
        key
    });
};
export const showNotification = (content, type = 'info') => {
    const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1);
    const copyToClipboard = async (text, key) => {
        try {
            await navigator.clipboard.writeText(text);
            notification.destroy(key);
        }
        catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };
    const key = uuid();
    notification.config({
        placement: 'topRight',
        // showProgress: true,
        duration: 3,
        maxCount: 3
    });
    createNotification(type, capitalizedType, content, () => copyToClipboard(content, key), key);
};
